<template>
    <div class="main">
        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />

        <!-- 主體 -->
        <div class="mainContent">
            
            <!-- 智慧農場 -->
            <div class="agri-result-group pwa pb-1">
                <!-- 條件選單 -->
                <b-container> 
                    <!-- 標題 -->
                    <PwaTitle :textTitle="title" :showMore="false"></PwaTitle>
                    <div class="w3-row">
                        <!-- 地點 -->
                        <div class="w3-col w3-container m4 l4">
                            <p>
                                <label class="global-descript">{{ input.location.text }}</label>
                                <v-select class="global-descript" v-model="input.location.value" :options="input.location.list" :reduce="(option) => option.value" label="text"></v-select>
                            </p>
                        </div>
                        <!-- 颱風 -->
                        <div class="w3-col w3-container m4 l4">
                            <p>
                                <label class="global-descript">{{ input.typhoon.text }}</label>
                                <v-select class="global-descript" v-model="input.typhoon.value" :options="input.typhoon.list" :reduce="(option) => option.value" label="text"></v-select>
                            </p>
                            <div class="global-descript">{{ descript }}</div>
                        </div>
                    </div>
                    
                    
                </b-container>

                <!--T+1 -->
                <b-container>
                    <!-- 標題 -->
                    <PwaTitle :textTitle="chart.t1.text" :showMore="false"></PwaTitle>
                    <!-- 圖表 -->
                    <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                        <div id="typhoon_flood_chart_t1" class="typhoon_flood_chart" style="height: 150px;width: 100%; background:#F9F9F9; min-width: 350px;"></div>
                    </div>
                </b-container>
                <!--T+2 -->
                <b-container>
                    <!-- 標題 -->
                    <PwaTitle :textTitle="chart.t2.text" :showMore="false"></PwaTitle>
                    <!-- 圖表 -->
                    <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                        <div id="typhoon_flood_chart_t2" class="typhoon_flood_chart" style="height: 150px;width: 100%; background:#F9F9F9; min-width: 350px;"></div>
                    </div>
                </b-container>
                <!--T+3 -->
                <b-container>
                    <!-- 標題 -->
                    <PwaTitle :textTitle="chart.t3.text" :showMore="false"></PwaTitle>
                    <!-- 圖表 -->
                    <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                        <div id="typhoon_flood_chart_t3" class="typhoon_flood_chart" style="height: 150px;width: 100%; background:#F9F9F9; min-width: 350px;"></div>
                    </div>
                </b-container>
                <!--T+4 -->
                <b-container>
                    <!-- 標題 -->
                    <PwaTitle :textTitle="chart.t4.text" :showMore="false"></PwaTitle>
                    <!-- 圖表 -->
                    <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                        <div id="typhoon_flood_chart_t4" class="typhoon_flood_chart" style="height: 150px;width: 100%; background:#F9F9F9; min-width: 350px;"></div>
                    </div>
                </b-container>
            </div> 

            
        </div>


    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
import PwaTitle from '@/components/pwa/PwaTitle.vue'
export default {
    created() {
        window.vue = this;
        if(!window.checkLogin()){ window.setPage("login");}               
    },  
    components: {
        Header,
        PwaTitle
    },
    data(){
        return {
            title: "颱風淹水潛勢專區",
            descript:"AI模型預報結果會根據前幾小時的雨量與水位變化，預報未來 1 至 4 小時的可能淹水情況。",
            //表單物件
            input:{
                //地點
                location:{
                    text:"地點",
                    value:"",
                    placeholder:"請選擇地點",
                    list:[],
                },
                //颱風
                typhoon:{
                    text:"颱風",
                    value:"",
                    placeholder:"請選擇颱風",
                    list:[],
                },
            },
            chart:{

                t1:{
                    text:"預報未來 1 小時",
                    observation:[],
                    estimation:[],
                    hour:[],
                },
                t2:{
                    text:"預報未來 2 小時",
                    observation:[],
                    estimation:[],
                    hour:[],
                },
                t3:{
                    text:"預報未來 3 小時",
                    observation:[],
                    estimation:[],
                    hour:[],
                },
                t4:{
                    text:"預報未來 4 小時",
                    descript:"AI 模型會根據前幾小時的雨量與水位資料，預測未來幾小時可能的淹水情況。",
                    observation:[],
                    estimation:[],
                    hour:[],
                }

            },

            //api 取得地點
            apiTyphoonFloodGroupByLocation: (data) => this.userRequest.get("/API/Default/TyphoonFloodGroupByLocation", data),   
            //api 取得颱風
            apiTyphoonFloodGroupByTyphoon: (data) => this.userRequest.get("/API/Default/TyphoonFloodGroupByTyphoon?Location="+this.input.location.value, data),
            //api 取得圖表
            apiTyphoonFloodChart: (data) => this.userRequest.get("/API/Default/TyphoonFloodChart?Location="+this.input.location.value+"&Typhoon="+this.input.typhoon.value, data), 
        }
    },
    watch: {

        //地點
        "input.location.value":function(val)
        {
            if(val != ""){ this.typhoonFloodGroupByTyphoon(); }     
        },          

        //颱風
        "input.typhoon.value":function(val)
        {
            if(val != ""){ this.typhoonFloodChart(); }     
        },
    },

    mounted() {

        this.typhoonFloodGroupByLocation();
        window.ChartTyphoonFloodT1 = null;
        window.ChartTyphoonFloodT2 = null;
        window.ChartTyphoonFloodT3 = null;
        window.ChartTyphoonFloodT4 = null;
    },
    methods: {

        //取得地點
        typhoonFloodGroupByLocation:function()
        {
            this.input.location.list = [];
            this.apiTyphoonFloodGroupByLocation({})
            .then((res)=>{

                const data = JSON.parse(res.data);            
                for(var i=0;i < data.length ; i++){

                    var item = data[i];
                    this.input.location.list.push({
                        text:item.Location,
                        value:item.Location
                    });
                }

                if(this.input.location.list.length > 0){ this.input.location.value = this.input.location.list[0].text; }             
            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });

        },

        //取得颱風
        typhoonFloodGroupByTyphoon:function()
        {
            this.input.typhoon.value = "";
            this.input.typhoon.list = [];
            this.apiTyphoonFloodGroupByTyphoon({})
            .then((res)=>{

                const data = JSON.parse(res.data);        
                for(var i=0;i < data.length ; i++){

                    var item = data[i];
                    this.input.typhoon.list.push({
                        text:item.Typhoon,
                        value:item.Typhoon
                    });
                }   
                
                if(this.input.typhoon.list.length > 0){ 
                    
                    this.input.typhoon.value = this.input.typhoon.list[0].text; 
                
                }
            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });

        },

        //取得圖表
        typhoonFloodChart:function()
        {
            this.chart.t1.observation = [];
            this.chart.t1.estimation = [];
            this.chart.t1.hour = [];

            this.chart.t2.observation = [];
            this.chart.t2.estimation = [];
            this.chart.t2.hour = [];

            this.chart.t3.observation = [];
            this.chart.t3.estimation = [];
            this.chart.t3.hour = [];

            this.chart.t4.observation = [];
            this.chart.t4.estimation = [];
            this.chart.t4.hour = [];

            this.apiTyphoonFloodChart({})
            .then((res)=>{

                const data = JSON.parse(res.data); 
                
                console.log(data);
                
                const t1 = data.t1;  
                const t2 = data.t2;  
                const t3 = data.t3;  
                const t4 = data.t4;  
                for(var i=0 ; i < t1.length ; i++){

                    var item = t1[i];
                    this.chart.t1.observation.push(item.Observation);
                    this.chart.t1.estimation.push(item.Estimation);
                    this.chart.t1.hour.push(item.Hour);
                }   

                for(var i2=0 ; i2 < t2.length ; i2++){

                    var item2 = t2[i2];
                    this.chart.t2.observation.push(item2.Observation);
                    this.chart.t2.estimation.push(item2.Estimation);
                    this.chart.t2.hour.push(item2.Hour);
                }   

                for(var i3=0 ; i3 < t3.length ; i3++){

                    var item3 = t3[i3];
                    this.chart.t3.observation.push(item3.Observation);
                    this.chart.t3.estimation.push(item3.Estimation);
                    this.chart.t3.hour.push(item3.Hour);
                }       


                for(var i4=0 ; i4 < t4.length ; i4++){

                    var item4 = t4[i4];
                    this.chart.t4.observation.push(item4.Observation);
                    this.chart.t4.estimation.push(item4.Estimation);
                    this.chart.t4.hour.push(item4.Hour);
                }  

                this.setChartTyphoonFloodT1();
                this.setChartTyphoonFloodT2();
                this.setChartTyphoonFloodT3();
                this.setChartTyphoonFloodT4();

            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });

        },

        setChartTyphoonFloodT1(){

            const _this = window.vue._data;
            window.ThreadTool.Delay(function(){
        
                window.setChartTyphoonFloodT1("#typhoon_flood_chart_t1",{

                    observation:_this.chart.t1.observation,
                    estimation:_this.chart.t1.estimation,
                    hour:_this.chart.t1.hour,
                    data:_this.chart.t1.hour,
                });

            },1500);
        },

        setChartTyphoonFloodT2(){

            const _this = window.vue._data;
            window.ThreadTool.Delay(function(){
        
                window.setChartTyphoonFloodT2("#typhoon_flood_chart_t2",{

                    observation:_this.chart.t2.observation,
                    estimation:_this.chart.t2.estimation,
                    hour:_this.chart.t2.hour,
                    data:_this.chart.t2.hour,
                });

            },1500);
        },

        setChartTyphoonFloodT3(){

            const _this = window.vue._data;
            window.ThreadTool.Delay(function(){
        
                window.setChartTyphoonFloodT3("#typhoon_flood_chart_t3",{

                    observation:_this.chart.t3.observation,
                    estimation:_this.chart.t3.estimation,
                    hour:_this.chart.t3.hour,
                    data:_this.chart.t3.hour,
                });

            },1500);
        },

        setChartTyphoonFloodT4(){

            const _this = window.vue._data;
            window.ThreadTool.Delay(function(){
        
                window.setChartTyphoonFloodT4("#typhoon_flood_chart_t4",{

                    observation:_this.chart.t4.observation,
                    estimation:_this.chart.t4.estimation,
                    hour:_this.chart.t4.hour,
                    data:_this.chart.t4.hour,
                });

            },1500);
        },

    }
}
</script>
<style scoped>

</style>